import * as R from 'ramda';

// Recursively measures how deeply an array is nested (0 for non-arrays).
export const getArrayDepth = (value: unknown): number =>
  R.is(Array, value) ? 1 + Math.max(...value.map(getArrayDepth)) : 0;

// Sort assets so non-array (point) geometries come before complex shapes
export const sortAssets = R.sortBy(
  R.pipe(R.path(['location', 'coordinates']), getArrayDepth),
);

// In identify mode (a non-empty list of ids), keep only matching items;
// otherwise return the items unchanged.
export const filterById = <T extends { id: string }>(
  items: T[],
  ids: string[] | null,
): T[] =>
  ids && ids.length > 0 ? items.filter(({ id }) => ids.includes(id)) : items;
